import type {
  StudentProfileResource,
  StudentProfileResourceMeta,
} from "api/generated";
import type { PortfolioProfile, PortfolioProfileMeta } from "portfolio/types";
import { shallowStudentFromDto, shallowStudentToDto } from "shared/mappers";

export const portfolioProfileFromDto = (
  data: StudentProfileResource,
): PortfolioProfile => {
  return {
    id: data.id,
    bannerImage: data.banner_image,
    myEducation: data.my_education,
    myHobbies: data.my_hobbies,
    myInterests: data.my_interests,
    aboutMe: data.about_me,
    profileImage: data.profile_image,
    user: shallowStudentFromDto(data.user),
    meta: portfolioProfileMetaFromDto(data.meta),
  };
};

const portfolioProfileMetaFromDto = (metaDto: StudentProfileResourceMeta) => {
  return {
    canEditProfileBanner: metaDto.can_edit_profile_banner,
    canEditProfilePicture: metaDto.can_edit_profile_picture,
  };
};

export const portfolioProfileToDto = (
  profile: PortfolioProfile,
): StudentProfileResource => {
  return {
    id: profile.id,
    banner_image: profile.bannerImage,
    my_education: profile.myEducation,
    my_hobbies: profile.myHobbies,
    my_interests: profile.myInterests,
    about_me: profile.aboutMe,
    profile_image: profile.profileImage,
    user: shallowStudentToDto(profile.user),
    meta: portfolioProfileMetaToDto(profile.meta),
  };
};

const portfolioProfileMetaToDto = (
  meta: PortfolioProfileMeta,
): StudentProfileResourceMeta => {
  return {
    can_edit_profile_banner: meta.canEditProfileBanner,
    can_edit_profile_picture: meta.canEditProfilePicture,
  };
};
